/**
 * Espejo en frontend del catálogo FIJO de permisos del Back Office.
 * La fuente de verdad vive en el backoffice-service; aquí se replican las claves
 * para poder referenciarlas de forma tipada en rutas, guards y directivas.
 * Si se agregan permisos en el backend, reflejarlos aquí.
 */
export const BackofficePermission = {
  // Catálogo de servicios
  CATALOG_VIEW_CATEGORIES: 'catalog:view_categories',
  CATALOG_VIEW_SERVICES: 'catalog:view_services',
  CATALOG_CREATE_CATEGORY: 'catalog:create_category',
  CATALOG_UPDATE_CATEGORY: 'catalog:update_category',
  CATALOG_SAVE_SERVICE: 'catalog:save_service',
  CATALOG_ACTIVATE_SERVICE: 'catalog:activate_service',
  CATALOG_UPDATE_SERVICE: 'catalog:update_service',
  CATALOG_PUBLISH_SERVICE: 'catalog:publish_service',
  CATALOG_DELETE_SERVICE: 'catalog:delete_service',
  CATALOG_MANAGE_SERVICE_DETAILS: 'catalog:manage_service_details',
  CATALOG_MANAGE_DOCUMENT_REQUIREMENTS: 'catalog:manage_document_requirements',

  // Cumplimiento / documentos
  COMPLIANCE_VIEW_DOCUMENT_TYPES: 'compliance:view_document_types',
  COMPLIANCE_APPROVE_USER_DOCUMENT: 'compliance:approve_user_document',
  COMPLIANCE_REJECT_USER_DOCUMENT: 'compliance:reject_user_document',

  // Postulaciones de prestador
  APPLICATIONS_VIEW: 'applications:view',
  APPLICATIONS_APPROVE: 'applications:approve',
  APPLICATIONS_REJECT: 'applications:reject',
  APPLICATIONS_UPDATE: 'applications:update',

  // Configuraciones del sistema
  SYSTEM_CONFIGS_VIEW: 'system_configs:view',
  SYSTEM_CONFIGS_SAVE: 'system_configs:save',

  // Modalidades de viaje
  RIDE_MODALITIES_VIEW: 'ride_modalities:view',
  RIDE_MODALITIES_SAVE: 'ride_modalities:save',
  RIDE_MODALITIES_ACTIVATE: 'ride_modalities:activate',
  RIDE_MODALITIES_UPDATE: 'ride_modalities:update',
  RIDE_MODALITIES_PUBLISH: 'ride_modalities:publish',
  RIDE_MODALITIES_DELETE: 'ride_modalities:delete',
  RIDE_MODALITIES_MANAGE_DOCUMENT_REQUIREMENTS: 'ride_modalities:manage_document_requirements',

  // Banners
  BANNERS_VIEW: 'banners:view',
  BANNERS_CREATE: 'banners:create',
  BANNERS_UPDATE: 'banners:update',
  BANNERS_DELETE: 'banners:delete',

  // Correo
  EMAIL_VIEW_LOGS: 'email:view_logs',
  EMAIL_SEND: 'email:send',

  // Notificaciones push
  PUSH_NOTIFICATIONS_VIEW: 'push_notifications:view',
  PUSH_NOTIFICATIONS_SEND: 'push_notifications:send',

  // Catálogo de vehículos
  VEHICLE_CATALOG_VIEW: 'vehicle_catalog:view',
  VEHICLE_CATALOG_MANAGE_BRANDS: 'vehicle_catalog:manage_brands',
  VEHICLE_CATALOG_MANAGE_MODELS: 'vehicle_catalog:manage_models',

  // Tickets
  TICKETS_VIEW_REASONS: 'tickets:view_reasons',
  TICKETS_MANAGE_REASONS: 'tickets:manage_reasons',

  // Cupones
  COUPONS_VIEW: 'coupons:view',
  COUPONS_CREATE: 'coupons:create',
  COUPONS_UPDATE: 'coupons:update',
  COUPONS_DELETE: 'coupons:delete',

  // Liquidaciones
  SETTLEMENTS_VIEW: 'settlements:view',
  SETTLEMENTS_GENERATE: 'settlements:generate',
  SETTLEMENTS_UPDATE_STATUS: 'settlements:update_status',
  SETTLEMENTS_UPDATE_APPROVAL: 'settlements:update_approval',
  SETTLEMENTS_BULK_UPDATE: 'settlements:bulk_update',
  SETTLEMENTS_UPDATE_NOTES: 'settlements:update_notes',
  SETTLEMENTS_CONFIRM_PERIOD: 'settlements:confirm_period',

  // Retiros
  WITHDRAWALS_VIEW: 'withdrawals:view',
  WITHDRAWALS_APPROVE: 'withdrawals:approve',
  WITHDRAWALS_REVERT: 'withdrawals:revert',
  WITHDRAWALS_CONFIRM: 'withdrawals:confirm',
  WITHDRAWALS_REJECT: 'withdrawals:reject',
  WITHDRAWALS_UPDATE_NOTES: 'withdrawals:update_notes',

  // Mensajes
  MESSAGES_VIEW: 'messages:view',

  // Analítica
  ANALYTICS_VIEW: 'analytics:view',

  // Gestión de administradores
  USERS_VIEW: 'users:view',
  USERS_CREATE: 'users:create',
  USERS_UPDATE: 'users:update',
  USERS_CHANGE_STATE: 'users:change_state',
  USERS_RESET_PASSWORD: 'users:reset_password',
  USERS_ASSIGN_ROLE: 'users:assign_role',

  // Roles y permisos
  ROLES_VIEW: 'roles:view',
  ROLES_CREATE: 'roles:create',
  ROLES_UPDATE: 'roles:update',
  ROLES_CHANGE_STATUS: 'roles:change_status',
} as const;

export type BackofficePermissionKey =
  (typeof BackofficePermission)[keyof typeof BackofficePermission];

/** Respuesta de GET /backoffice/users/me/permissions */
export interface IMyPermissions {
  permissions: string[];
  is_super: boolean;
}
